/* トップページ
----------------------------------------------*/
$(function () {
  var mvSwiper = new Swiper(".js-mv-swiper", {
    autoplay: true,
    centeredSlides: true,
    loop: true,
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    slidesPerView: 1,
    speed: 1000,
    breakpoints: {
      769: {
        slidesPerView: 1.6,
      },
    },
  });
});

$(function () {
  var swiperOptions = {
    observer: true,
    observeParents: true,
    slidesPerView: 2.112,
    slidesPerGroup: 2,
    spaceBetween: 20,
    navigation: {
      prevEl: ".swiper-button-prev",
      nextEl: ".swiper-button-next",
    },
    breakpoints: {
      769: {
        pagination: false,
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 24,
        speed: 800,
      },
    },
  };

  var rankingSwiper = new Swiper(".js-ranking-swiper", swiperOptions);
  var pickupSwiper = new Swiper(".js-pickup-swiper", swiperOptions);
});
